import React, { useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './changePassword.css';
import { useDispatch, useSelector } from 'react-redux';
import { updatePassword } from '../../../apiServices';
import { showNotificationIfAllowed } from '../../../utils/pushNotification';
import { Eye, EyeOff, AlertCircle } from 'react-feather';
import CustomSuccessModal from 'components/CustomSuccessModal';
import CustomAlertModal from 'components/CustomAlertModal';


function ChangePassword(props) {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [messageAlert, setMessageAlert] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errors, setErrors] = useState({
        oldPassword: false,
        newPassword: false,
        confirmPassword: false
    });
    const dispatch = useDispatch();
    const token = useSelector((state) => state.apiService.token);
    const userData = useSelector((state) => state.apiService.login);

    const validatePassword = (password) => {
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
        return pattern.test(password);
    };
    const handleOldPasswordChange = (e) => {
        const value = e.target.value;
        setOldPassword(value);
        setErrors(prev => ({
            ...prev,
            oldPassword: value && value !== newPassword
        }));
    }
    const handleNewPasswordChange = (e) => {
        const value = e.target.value;
        setNewPassword(value);
        setErrors(prev => ({
            ...prev,
            newPassword: value && !validatePassword(value)
        }));
        if(newPassword.length>0&&confirmPassword!==value){
            setErrors(prev => ({
                ...prev,
                confirmPassword: true
            }));
        }else{
            setErrors(prev => ({
                ...prev,
                confirmPassword: false
            }));
        }
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);
        setErrors(prev => ({
            ...prev,
            confirmPassword: value && value !== newPassword
        }));
                
    };
    const togglePasswordVisibility = (field) => {
        switch(field) {
            case 'oldPassword':
                setShowOldPassword(!showOldPassword);
                break;
            case 'newPassword':
                setShowNewPassword(!showNewPassword);
                break;
            case 'confirmPassword':
                setShowConfirmPassword(!showConfirmPassword);
                break;
            default:
                break;
        }
    };
    const params = {
        user_id: userData.user_id,
        OldPassword: oldPassword,
        NewPassword: newPassword,
        token: token
       
    }
    const handleCloseModal = () => {
        if(isSuccess){  
            setMessageAlert(false);
            setIsSuccess(false);
            props.onClose();
        }else{
            setMessageAlert(false);
            setIsSuccess(false);
        }
    }
    const handleOverlayClick = () => {
        setMessageAlert(false);
    }

    const handleChangePassword = async () => {
        let hasErrors = false;
        const newErrors = {
            oldPassword: false,
            newPassword: false,
            confirmPassword: false
        };

        // First validation: Check if all fields are filled
        if (!oldPassword || !newPassword || !confirmPassword) {
            if (!oldPassword) {
                newErrors.oldPassword = true;
            }
            if (!newPassword) {
                newErrors.newPassword = true;
            }
            if (!confirmPassword) {
                newErrors.confirmPassword = true;
            }
            hasErrors = true;
            setErrors(newErrors);
            return;
        } 
        // Second validation: Check password pattern
        else if (!validatePassword(newPassword)) {
            newErrors.newPassword = true;
            hasErrors = true;
            setErrors(newErrors);
            return;
        }
        // Third validation: Check if passwords match
        else if (newPassword !== confirmPassword) {
            newErrors.confirmPassword = true;
            hasErrors = true;
            setErrors(newErrors);
            return;
        }
        // All validations passed, proceed with API call
        else {
            dispatch(updatePassword(params)).then((res) => {
                const status = res.payload?.status;
                let body = res.payload?.data;
                if (typeof body === 'string') {
                    const trimmed = body.replace(/^\uFEFF/, '').trim();
                    if (trimmed.startsWith('{')) {
                        try {
                            body = JSON.parse(trimmed);
                        } catch (e) {
                            body = trimmed;
                        }
                    } else {
                        body = trimmed;
                    }
                }

                const notice = body && typeof body === 'object' ? body : null;
                const isPasswordUpdated = status === 200 && (body === '' || notice?.title || notice?.message);

                if (isPasswordUpdated) {
                    setMessageAlert(true);
                    setMessage("Password Changed Successfully");
                    setIsSuccess(true);
                    showNotificationIfAllowed({
                        userId: notice?.user_id || userData?.user_id,
                        token: token || userData?.Token,
                        title: notice?.title || "Password Updated Successfully",
                        body: notice?.message || "Password Changed Successfully",
                        url: notice?.url || window.location.href,
                        tag: `pmr-password-${Date.now()}`,
                    }).catch(() => {});
                } else {
                    setIsSuccess(false);
                    setMessageAlert(true);
                    setMessage(typeof body === 'string' ? body : (notice?.message || "Unable to change password"));
                }
            });
        }
    };

    return (
        <>
            {messageAlert && isSuccess && (
                <CustomSuccessModal show={messageAlert} onHide={handleCloseModal} message={message} />
            )}
            {messageAlert && !isSuccess && (
                <CustomAlertModal show={messageAlert} onHide={handleCloseModal} message={message} />
            )}
            <div className="password-modal-overlay">
                <div className="password-modal">
                    <div className="password-modal-header">
                        <span className="password-modal-title">Change Password</span>
                    </div>
                    <div className="password-modal-body">
                        <div className="password-form-group">
                            <label className="password-label mb-1">Current Password</label>
                            <div className="password-input-container">
                                <input
                                    type={showOldPassword ? "text" : "password"}
                                    className={`password-form-control ${(errors.oldPassword && oldPassword.length==0) ? 'error' : ''}`}
                                    value={oldPassword}
                                    onChange={handleOldPasswordChange}
                                    placeholder="Enter current password"
                                />
                                {(errors.oldPassword && oldPassword.length==0) && (
                                    <AlertCircle size={18} className="error-icon" />
                                )}
                                <button
                                    type="button"
                                    className="password-toggle-btn"
                                    onClick={() => togglePasswordVisibility('oldPassword')}
                                >
                                    {showOldPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                                </button>
                            </div>
                            {(errors.oldPassword && oldPassword.length === 0) && (
                                <div className="password-error">Current password is required</div>
                            )}
                        </div>
                        
                        <div className="password-form-group">
                            <label className="password-label mb-1">New Password</label>
                            <div className="password-input-container">
                                <input
                                    type={showNewPassword ? "text" : "password"}
                                    className={`password-form-control ${(errors.newPassword && newPassword.length==0) ? 'error' : ''}`}
                                    value={newPassword}
                                    onChange={handleNewPasswordChange}
                                    placeholder="Enter new password"
                                />
                                {(errors.newPassword && newPassword.length==0) && (
                                    <AlertCircle size={18} className="error-icon" />
                                )}
                                <button
                                    type="button"
                                    className="password-toggle-btn"
                                    onClick={() => togglePasswordVisibility('newPassword')}
                                >
                                    {showNewPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                                </button>
                            </div>
                            {errors.newPassword && (
                                <>
                                    {/* <div className="password-error">
                                        {!newPassword ? "New password is required" : "Password must meet the requirements below:"}
                                    </div> */}
                                    {newPassword.length > 0 && (
                                        <div className="password-error">
                                            Must have at least 1 number, 1 special character, 1 lowercase and 1 uppercase character.
                                        </div>
                                        
                                    )}
                                </>
                            )}
                            {(errors.newPassword && newPassword.length === 0) && (
                                <div className="password-error">New password is required</div>
                            )}
                        </div>
                        
                        <div className="password-form-group">
                            <label className="password-label mb-1">Confirm Password</label>
                            <div className="password-input-container">
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    className={`password-form-control ${(errors.confirmPassword && confirmPassword.length==0) ? 'error' : ''}`}
                                    value={confirmPassword}
                                    onChange={handleConfirmPasswordChange}
                                    placeholder="Confirm new password"
                                />
                                {(errors.confirmPassword && confirmPassword.length==0) && (
                                    <AlertCircle size={18} className="error-icon" />
                                )}
                                <button
                                    type="button"
                                    className="password-toggle-btn"
                                    onClick={() => togglePasswordVisibility('confirmPassword')}
                                >
                                    {showConfirmPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                                </button>
                            </div>
                            {errors.confirmPassword && (
                                <div className="password-error">
                                    {!confirmPassword ? "Confirm password is required" : "Passwords do not match"}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="password-modal-footer">
                        <button 
                            className="password-btn password-btn-primary" 
                            onClick={handleChangePassword}
                        >
                            Change Password
                        </button>
                        <button className="password-btn password-btn-danger" onClick={props.onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ChangePassword;
